import React from 'react';
import './Orb.css';

const Orb = ({ index }) => {
  return (
    <div className={`orb orb-${index + 1}`}></div>
  );
};

export default Orb;
